// src/components/SessionProvider.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import config from '../config.js'
import { Loader } from './loader'

const SessionContext = createContext();

export const useSession = () => useContext(SessionContext);

export default function SessionProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${config.apiPath}validate-session/check-session.php`, {
      method: 'GET',
      credentials: 'include', // important for cookies
    })
      .then((res) => res.json())
      .then((data) => {
          setSession(data);
          setLoading(false);
      })
      .catch((err) => {
        console.error('Session check failed:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <Loader />;

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
}
